import { ValueOf } from '@vy/utils';

export const SIDE_NAV_BAR_LABELS = Object.freeze({
  Home: 'Home',
  AiAgents: 'Vayu Agents',
  Customers: 'Customers',
  Plans: 'Plans & Pricing',
  Invoices: 'Invoices',
  Overview: 'Overview',
  Payments: 'Payments',
  Usage: 'Usage',
  Events: 'Events',
  DataMetering: 'Data Metering',
  Integrations: 'Integrations',
  Products: 'Products',
  Reports: 'Reports',
});

export type SideNavBarLabel = ValueOf<typeof SIDE_NAV_BAR_LABELS>;
